import { SSOProvider } from './sso-provider.enum';

// The login page's sign-in options: the SSO providers, plus HRLocker, which signs people in on its own page
// rather than through an OAuth flow of ours, so it isn't an SSOProvider.
export const HRLOCKER = 'HRLOCKER';
export type SignInProvider = SSOProvider | typeof HRLOCKER;
